<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; decorative?: boolean }>(), {
  size: 44,
  decorative: true,
});
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" :aria-hidden="decorative ? 'true' : undefined" :role="decorative ? undefined : 'img'">
    <rect x="2" y="2" width="44" height="44" rx="13" fill="#0B3646" stroke="#155E75" stroke-width="2" />
    <path d="M13 14.5H35C36.657 14.5 38 15.843 38 17.5V28.5C38 30.157 36.657 31.5 35 31.5H25.5L20 36V31.5H13C11.343 31.5 10 30.157 10 28.5V17.5C10 15.843 11.343 14.5 13 14.5Z" fill="#ECFEFF" />
    <path d="M15.5 27L20 22.5L24 25.5L31.5 19" stroke="#0891B2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="31.5" cy="19" r="2" fill="#06B6D4" />
  </svg>
</template>
